import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';

import { defaultValues } from './model';
import { inventoryVendorFormSchema } from './schemas';

export function useFormDefinition() {
  return useForm({
    resolver: zodResolver(inventoryVendorFormSchema),
    defaultValues,
  });
}
